// export const API_URL = "http://localhost:8099/";
export const API_URL = "https://api.blizzardpro.com/";
// export const API_URL = "https://api.dev3.io/";
